module.exports = __webpack_public_path__ + "5efb667a0229919ba91bd3caae81c368.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/armagan-amcalar.jpg
// module id = 504
// module chunks = 0